import {
  SlTag
} from "./chunk.MTM3FR3I.js";

// src/components/tag/tag.ts
var tag_default = SlTag;
SlTag.define("sl-tag");

export {
  tag_default
};
